"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProfileModal = EditProfileModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var file_1 = require("../../features/apis/file");
var user_1 = require("../../features/apis/user");
var api_error_message_1 = require("../../utils/api-error-message");
var validation_1 = require("../../utils/validation");
var button_component_1 = require("../ui/button-component");
var file_upload_component_1 = require("../ui/file-upload-component");
var labeled_field_1 = require("../ui/labeled-field");
var text_component_1 = require("../ui/text-component");
function EditProfileModal(props) {
    var _this = this;
    var _a;
    var isOpen = props.isOpen, user = props.user, onClose = props.onClose, onSaved = props.onSaved;
    var _b = (0, react_2.useState)(user.name), name = _b[0], setName = _b[1];
    var _c = (0, react_2.useState)(user.surname), surname = _c[0], setSurname = _c[1];
    var _d = (0, react_2.useState)((_a = user.phone_number) !== null && _a !== void 0 ? _a : ""), phoneNumber = _d[0], setPhoneNumber = _d[1];
    var _e = (0, react_2.useState)(""), error = _e[0], setError = _e[1];
    var _f = (0, react_2.useState)(null), pendingPhoto = _f[0], setPendingPhoto = _f[1];
    var _g = (0, react_2.useState)(false), isPhotoUploading = _g[0], setIsPhotoUploading = _g[1];
    var _h = (0, react_2.useState)(0), uploadResetKey = _h[0], setUploadResetKey = _h[1];
    var _j = (0, user_1.useUpdateOwnProfileMutation)(), updateOwnProfile = _j[0], isSaving = _j[1].isLoading;
    var _k = (0, file_1.useCompleteUploadMutation)(), completeUpload = _k[0], isCompleting = _k[1].isLoading;
    var isBusy = isSaving || isCompleting;
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    (0, react_2.useEffect)(function () {
        var _a;
        if (isOpen) {
            setName(user.name);
            setSurname(user.surname);
            setPhoneNumber((_a = user.phone_number) !== null && _a !== void 0 ? _a : "");
            setError("");
            setPendingPhoto(null);
            setUploadResetKey(function (key) { return key + 1; });
        }
    }, [isOpen, user]);
    var handleClose = function () {
        if (requestInFlightRef.current || isBusy)
            return;
        requestTokenRef.current += 1;
        onClose();
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var trimmedName, trimmedSurname, trimmedPhoneNumber, requestToken, completed, response, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current)
                        return [2 /*return*/];
                    setError("");
                    trimmedName = name.trim();
                    trimmedSurname = surname.trim();
                    trimmedPhoneNumber = phoneNumber.trim();
                    if (!trimmedName || !trimmedSurname) {
                        setError("Please provide your name and surname.");
                        return [2 /*return*/];
                    }
                    if (trimmedPhoneNumber && !(0, validation_1.isValidPhoneNumber)(trimmedPhoneNumber)) {
                        setError("Please enter a valid phone number.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    if (!pendingPhoto) return [3 /*break*/, 3];
                    return [4 /*yield*/, completeUpload(pendingPhoto.file.id).unwrap()];
                case 2:
                    completed = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!completed.success) {
                        setError(completed.message || "Unable to save your profile picture. Please try again.");
                        return [2 /*return*/];
                    }
                    // The photo is now active server-side: a retry after a failed profile update must not complete it again,
                    // and closing or discarding the picker must not delete it.
                    pendingPhoto.markActivated();
                    setPendingPhoto(null);
                    _a.label = 3;
                case 3: return [4 /*yield*/, updateOwnProfile({
                        name: trimmedName,
                        surname: trimmedSurname,
                        phone_number: trimmedPhoneNumber,
                    }).unwrap()];
                case 4:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to update your profile. Please try again.");
                        return [2 /*return*/];
                    }
                    onSaved(response.content);
                    requestInFlightRef.current = false;
                    handleClose();
                    return [2 /*return*/];
                case 5:
                    requestError_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to update your profile. Please try again."));
                    return [3 /*break*/, 7];
                case 6:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isBusy, isKeyboardDismissDisabled: isBusy, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isBusy }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", weight: "bold", color: "dark-gray-1", label: "Edit Profile" }) }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { className: "p-1", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(file_upload_component_1.FileUploadComponent, { ownerType: "users", ownerId: user.uid, category: "profile_photo", variant: "avatar", label: "Profile Picture", currentUrl: user.photo_url, isDisabled: isBusy, resetKey: uploadResetKey, onPendingFileChange: setPendingPhoto, onUploadingChange: setIsPhotoUploading }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Name", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Name", value: name, onChange: setName, isDisabled: isBusy, isRequired: true, fullWidth: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Name", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Surname", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Surname", value: surname, onChange: setSurname, isDisabled: isBusy, isRequired: true, fullWidth: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Surname", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Phone Number", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Phone Number", value: phoneNumber, onChange: setPhoneNumber, isDisabled: isBusy, fullWidth: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Phone number (optional)", className: "rounded-md" }) }) }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isBusy, variant: "secondary", className: "rounded-md" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Save Changes", onPress: handleSave, isPending: isBusy, isDisabled: isBusy || isPhotoUploading || !name.trim() || !surname.trim(), color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light", className: "rounded-md" })] })] }) }) }) }));
}
